import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import Card from "components/card/custom";
import DivLoader from "components/divloader/DivLoader";
import React, { useContext, useState } from "react";
import { SettlementRowObj } from "..";
import CreatePaymentMethoddModal from "./CreatePaymentMethod";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
} from "@chakra-ui/react";
import { Portal } from "@chakra-ui/portal";
import {
  MdCancel,
  MdCheckCircle,
  MdDelete,
  MdHighlightOff,
  MdWarning,
} from "react-icons/md";
import Searchbox from "components/fields/Searchbox";
import { BsArrowUp, BsArrowDown } from "react-icons/bs";
import Pagination from "components/pagination";
import toast from "react-hot-toast";
import {
  approvedSettlement,
  deleteSettlementReport,
  downloadSettlementReport,
  checkTransactionAvailableSettlementReport,
} from "api/settlement";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalFooter,
} from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import CrerateSettlementReport from "./CrerateSettlementReport";
import SettlementReport from "./settlementReport";
import InputField from "components/fields/InputField";
import { FaCheckCircle } from "react-icons/fa";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { RiArrowUpDownFill } from "react-icons/ri";
import { ClientContext } from "ClientProvider";
import FilterModal from "./FilterModal";
import { getAllClients } from "api/clients";

const columnHelper = createColumnHelper<SettlementRowObj>();

function SettlementTable(props: {
  tableData: any;
  fetchAllsettlement: () => void;
  isLoading: boolean;
  page: number;
  setPage: any;
  totalpage: number;
  totalItems: number;
  currentPage: number;
  pageSize: number;
  setPageSize: any;
  roleData: any;
  timeZone: any;
  allCardType: any;
  onValueChange: (value: string) => void;
  allOrgDetails: any;
  filter: any; 
  setFilter: (value: any) => void;
  setClearClick: () => void;
  filterData: () => void;
}) {
  const {
    tableData,
    fetchAllsettlement,
    page,
    setPage,
    currentPage,
    totalpage,
    totalItems,
    pageSize,
    setPageSize,
    roleData,
    timeZone,
    allCardType,
    onValueChange,
    allOrgDetails,
    setFilter,
    filter,
    setClearClick,
    filterData
  } = props;

  let defaultData = tableData;
  let showPaymentName =
    roleData[0]?.payment_method?.value?.show_payment_method_name;

  const { singleRoleData } = useContext(ClientContext);
  const [isOpenDelete, setIsopenDelete] = useState(false);
  const [payoutStatus, setPayoutStatus] = useState(false);
  const [settlmenetStatus, setSettlmenetStatus] = useState(false);
  const [DeleteRowId, setDeleteRowId] = useState("");
  const [isOpenApprove, setIsopenApprove] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [isDownloadFile, setIsDownloadFile] = useState(false);
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
  const [isCloseAppModal, setIsCloseAppModal] = useState<boolean>(false);
  const [markStatus, setMarkStatus] = useState("approved");
  const [loadingApproveSettlement, setLoadingApproveSettlement] =
    useState(false);
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [searchVal, setSearchVal] = React.useState<any>("");
  const [data, setData] = React.useState(() => [...defaultData]);
  const [netPayout, setNetPayout] = React.useState({
    usdtForex: null,
    withdrawalFee: null,
    settlementFee: null,
    hash: null,
  });
  const [apprveErrors, setApproveErrors] = useState<any>({});
  const [USDTForexRate, setUSDTForexRate] = React.useState<any>([]);
  const [TableApproveData, setTableApproveData] = useState<any>();

  const [subClientsData, setSubClientsData] = useState([]);

  const handelOnDownloadCSV = (sid: any) => {
    downloadSettlementReport(sid)
      .then((response) => {
        const csvText = response;
        const blob = new Blob([csvText], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "generated_data.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Download Completed");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
            "Something went wrong while downloading CSV"
        );
      });
  };

  const deleteSettlementReportFun = (id: any) => {
    setIsDeleteLoading(true);
    deleteSettlementReport(DeleteRowId)
      .then((res) => {
        toast.success("Record deleted successfully!");
        setIsDeleteLoading(false);
        fetchAllsettlement();
        handleClose();
      })
      .catch((error) => {
        setIsDeleteLoading(false);
        toast.error("Something went wrong!");
      });
  };

  const handleDownloadReport = (data: any) => {
    setIsDownloadFile(true);
    downloadSettlementReport(data?.id)
      .then((res) => {
        toast.success("Success!");
        data.takeAPIResponse(res);
      })
      .catch((error) => {
        toast.error("Something went wrong!");
      })
      .finally(() => {
        setIsDownloadFile(false);
      });
  };

  const handlePressonEye = (infoData: any) => {
    setUSDTForexRate([]);
    setApproveErrors({});
    setNetPayout({
      usdtForex: null,
      withdrawalFee: null,
      settlementFee: null,
      hash: null,
    });
    setLoadingApproveSettlement(true);

    const settlementId = infoData?.row?.original?.id;
    checkTransactionAvailableSettlementReport(settlementId)
      .then((data: any) => {
        if (data?.Is_transction_available) {
          const settlementData = infoData?.row?.original;
          setSettlmenetStatus(
            settlementData?.settlement_status === "approved"
          );
          setPayoutStatus(settlementData?.payout_status === "paid");
          setNetPayout({
            usdtForex: settlementData?.usdtForex || null,
            settlementFee: settlementData?.settlement_fee ?? "",
            withdrawalFee: settlementData?.withdrawal_fee ?? "",
            hash: settlementData?.hash ?? "",
          });

          const forexRates = settlementData?.usdt_forex ?? [];
          if (forexRates.length > 0) {
            const forexMapped = forexRates.map((item: any) => {
              const currencySummary =
                settlementData?.settlement_history_details?.find(
                  (s: any) => s.summary_currency === item.currency
                );
              return {
                currency: item.currency,
                forex_rate: Number(item.forex_rate),
                netPayOut:
                  Number(
                    currencySummary?.summary_report_table_details
                      ?.net_payout || 0
                  ) * Number(item.forex_rate),
              };
            });
            setUSDTForexRate(forexMapped);
          }

          setTableApproveData(settlementData);
          setIsopenApprove(true);
        } else {
          setIsopenApprove(false);
          toast.error(
            "Oops! There are no transaction of clients for the organization in the selected date period."
          );
        }
      })
      .catch((error: any) => {
        setIsopenApprove(false);
        console.info(error);
      })
      .finally(() => {
        setLoadingApproveSettlement(false);
      });
  };

  const validateApproveData = () => {
    let newErrors: any = {};

    if (netPayout.withdrawalFee == null || netPayout.withdrawalFee === "")
      newErrors.withdrawalFee = "The field is required";
    if (Number(netPayout.withdrawalFee) <= 0)
      newErrors.withdrawalFee = "Value must be greater than 0";
    if (netPayout.settlementFee == null || netPayout.settlementFee === "")
      newErrors.settlementFee = "The field is required";
    if (Number(netPayout.settlementFee) <= 0)
      newErrors.settlementFee = "Value must be greater than 0";
    if (settlmenetStatus && !netPayout.hash)
      newErrors.hash = "The field is required";

    let forexErrors: any = {};
    TableApproveData?.settlement_history_details?.forEach((item: any) => {
      const forexEntry = USDTForexRate.find(
        (f: any) => f.currency === item.summary_currency
      );
      if (
        !forexEntry ||
        forexEntry.forex_rate === "" ||
        forexEntry.forex_rate == null
      ) {
        forexErrors[item.summary_currency] = "The field is required";
      } else if (Number(forexEntry.forex_rate) <= 0) {
        forexErrors[item.summary_currency] = "Value must be greater than 0";
      }
    });
    if (Object.keys(forexErrors).length > 0) {
      newErrors.forex_rate = forexErrors;
    }
    setApproveErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmitApprovedSettlement = () => {
    const validateApprove = validateApproveData();
    if (validateApprove) {
      setIsApproveLoading(true);
      let payload = {
        USDT_forex_rate: USDTForexRate.map((mData: any) => ({
          currency: mData?.currency,
          forex_rate: mData?.forex_rate,
        })),
        withdrawal_fees: netPayout?.withdrawalFee,
        settlement_fees: netPayout?.settlementFee,
        hash: netPayout?.hash,
        settlement_status: markStatus,
        payout_status:
          markStatus == "approved" && netPayout?.hash ? "paid" : "unpaid",
        USDT_total_payout:
          (
            Number(
              USDTForexRate?.reduce((total: any, num: any) => {
                return Number(total) + Number(num?.netPayOut);
              }, 0)
            ) -
            parseFloat(netPayout?.settlementFee || 0) -
            parseFloat(netPayout?.withdrawalFee || 0)
          )?.toFixed(2) || "",
      };
      approvedSettlement(payload, TableApproveData?.id)
        .then((res) => {
          setIsApproveLoading(false);
          toast.success(res?.message);
          fetchAllsettlement();
          handleApproveClose();
        })
        .catch((error) => {
          setIsApproveLoading(false);
          const errorMessage = error.response.data.message;
          toast.error(errorMessage ? errorMessage : error?.message);
        });
    }
  };

  /* ── Avatar color cycling (matching OrgTable) ── */
  const avatarColors = [
    {
      bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)",
      border: "#bbf7d0",
      color: "#15803d",
    },
    {
      bg: "linear-gradient(135deg,#eff6ff,#dbeafe)",
      border: "#bfdbfe",
      color: "#2563eb",
    },
    {
      bg: "linear-gradient(135deg,#faf5ff,#ede9fe)",
      border: "#ddd6fe",
      color: "#7c3aed",
    },
    {
      bg: "linear-gradient(135deg,#fffbeb,#fef3c7)",
      border: "#fde68a",
      color: "#d97706",
    },
    {
      bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)",
      border: "#fecdd3",
      color: "#e11d48",
    },
  ];
  const getAvatarStyle = (index: number) =>
    avatarColors[index % avatarColors.length];

  const columns = [
    columnHelper.accessor("organization", {
      id: "organization",
      header: () => <span className="st-th">Organization</span>,
      cell: (info: any) => {
        const style = getAvatarStyle(info.row.index);
        return (
          <div className="st-name-cell">
            <div
              className="st-org-avatar"
              style={{
                background: style.bg,
                border: `1.5px solid ${style.border}`,
                color: style.color,
              }}
            >
              {info.row.original?.organization?.name
                ?.charAt(0)
                ?.toUpperCase() || "O"}
            </div>
            <span className="st-name">
              {info.row.original?.organization?.name}
            </span>
          </div>
        );
      },
      sortingFn: (rowA, rowB) => {
        const nameA = rowA.original.organization?.name?.toLowerCase() || "";
        const nameB = rowB.original.organization?.name?.toLowerCase() || "";
        return nameA.localeCompare(nameB);
      },
      enableSorting: true,
    }),
    columnHelper.accessor("client", {
      id: "client",
      header: () => <span className="st-th">Client</span>,
      cell: (info: any) => (
        <span className="st-cell-text">
          {info?.row.original?.client
            ?.map((m: any) => m?.name)
            .join(", ")}
        </span>
      ),
      sortingFn: (rowA, rowB) => {
        const nameA =
          rowA.original.client
            ?.map((m: any) => m?.name)
            .join(", ")
            .toLowerCase() || "";
        const nameB =
          rowB.original.client
            ?.map((m: any) => m?.name)
            .join(", ")
            .toLowerCase() || "";
        return nameA.localeCompare(nameB);
      },
      enableSorting: true,
    }),
    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => <span className="st-th">Created Date</span>,
      cell: (info: any) => (
        <span className="st-date">{info.row.original?.created_at}</span>
      ),
      sortingFn: (rowA, rowB) =>
        new Date(rowA.original.created_at).getTime() -
        new Date(rowB.original.created_at).getTime(),
      enableSorting: true,
    }),
    columnHelper.accessor("total_payout", {
      id: "total_payout",
      header: () => <span className="st-th">Total Payout</span>,
      cell: (info: any) => (
        <span className="st-payout">
          {info?.row?.original?.is_settlement_approved
            ? info.row.original?.total_payout
              ? "$" + Number(info.row.original?.total_payout)?.toFixed(2)
              : ""
            : <span className="st-dash">—</span>}
        </span>
      ),
    }),
    columnHelper.accessor("settlement_status", {
      id: "settlement_status",
      header: () => <span className="st-th">Settlement</span>,
      cell: (info: any) => {
        const approved =
          info?.row?.original?.settlement_status === "approved";
        return (
          <span
            className={`st-status-pill ${
              approved
                ? "st-status-pill--green"
                : "st-status-pill--red"
            }`}
          >
            <span
              className={`st-status-dot ${
                approved
                  ? "st-status-dot--green"
                  : "st-status-dot--red"
              }`}
            />
            {approved ? "Approved" : "Un-approved"}
          </span>
        );
      },
    }),
    columnHelper.accessor("payout_status", {
      id: "payout_status",
      header: () => <span className="st-th">Payment</span>,
      cell: (info: any) => {
        const paid = info?.row?.original?.payout_status === "paid";
        return (
          <span
            className={`st-status-pill ${
              paid ? "st-status-pill--green" : "st-status-pill--amber"
            }`}
          >
            <span
              className={`st-status-dot ${
                paid
                  ? "st-status-dot--green"
                  : "st-status-dot--amber"
              }`}
            />
            {paid ? "Paid" : "Unpaid"}
          </span>
        );
      },
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => <span className="st-th">Actions</span>,
      cell: (info: any) => {
        const settlementStatus = info?.row?.original?.settlement_status;
        const payoutStatusVal = info?.row?.original?.payout_status;

        let tooltipText = "";
        let clickable = "yes";

        if (
          settlementStatus === "approved" &&
          payoutStatusVal === "unpaid"
        ) {
          tooltipText = "Settlement Approved & Unpaid";
          clickable = "yes";
        } else if (
          settlementStatus === "approved" &&
          payoutStatusVal === "paid"
        ) {
          tooltipText = "Settlement Approved & Paid";
          clickable = "no";
        } else if (
          settlementStatus === "unapproved" &&
          payoutStatusVal === "unpaid"
        ) {
          tooltipText = "Approve Settlement";
          clickable = "yes";
        }

        return (
          <div className="st-actions">
            {roleData?.[0]?.settlement?.value?.approve_settlement && (
              <Popover trigger="hover" placement="bottom">
                <PopoverTrigger>
                  <button
                    className={`st-action-btn ${
                      clickable === "no"
                        ? "st-action-btn--blue-solid"
                        : "st-action-btn--blue"
                    }`}
                    onClick={
                      clickable !== "no"
                        ? () => handlePressonEye(info)
                        : undefined
                    }
                    disabled={clickable === "no"}
                    aria-label={tooltipText}
                  >
                    {clickable === "no" ? (
                      <FaCheckCircle size={14} />
                    ) : (
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 8 12 12 14 14" />
                      </svg>
                    )}
                  </button>
                </PopoverTrigger>
                <Portal>
                  <PopoverContent
                    border="1px solid #bfdbfe"
                    borderRadius="12px"
                    boxShadow="0 8px 24px rgba(15,23,42,0.08)"
                    bg="#eff6ff"
                    maxW="220px"
                    p="0"
                    overflow="hidden"
                    zIndex={9999}
                  >
                    <PopoverHeader
                      bg="#dbeafe"
                      fontSize="12px"
                      fontWeight="700"
                      color="#1d4ed8"
                      borderBottom="1px solid #bfdbfe"
                      px="14px"
                      py="10px"
                    >
                      {tooltipText}
                    </PopoverHeader>
                    <PopoverArrow bg="#eff6ff" />
                  </PopoverContent>
                </Portal>
              </Popover>
            )}

            {roleData?.[0]?.settlement?.value?.download_settlement && (
              <SettlementReport
                settlementInfo={info}
                handleDownloadReport={handleDownloadReport}
                fetchAllsettlement={fetchAllsettlement}
              />
            )}

            {settlementStatus === "unapproved" &&
              roleData?.[0]?.settlement?.value?.edit_settlement && (
                <CrerateSettlementReport
                  fetchAllsettlement={fetchAllsettlement}
                  allOrgDetails={allOrgDetails}
                  info={info}
                />
              )}

            {settlementStatus === "unapproved" &&
              roleData?.[0]?.settlement?.value?.delete_settlement && (
                <Popover trigger="hover" placement="bottom">
                  <PopoverTrigger>
                    <button
                      className="st-action-btn st-action-btn--red"
                      onClick={() => {
                        setIsopenDelete(true);
                        setDeleteRowId(info?.row?.original?.id);
                      }}
                      aria-label="Delete settlement"
                    >
                      <MdDelete size={14} />
                    </button>
                  </PopoverTrigger>
                  <PopoverContent
                    border="1px solid #fecaca"
                    borderRadius="12px"
                    boxShadow="0 8px 24px rgba(15,23,42,0.08)"
                    bg="#fef2f2"
                    maxW="200px"
                    p="0"
                    overflow="hidden"
                    zIndex={9999} 
                  >
                    <PopoverHeader
                      bg="#fee2e2"
                      fontSize="12px"
                      fontWeight="700"
                      color="#b91c1c"
                      borderBottom="1px solid #fecaca"
                      px="14px"
                      py="10px"
                    >
                      Delete Settlement
                    </PopoverHeader>
                    <PopoverArrow bg="#fef2f2" />
                  </PopoverContent>
                </Popover>
              )}
          </div>
        );
      },
      enableSorting: false,
    }),
  ];

  const columns2 = columns.slice(0, 6);

  const getSubClientsData = () => {
     getAllClients(0)
      .then((data) => setSubClientsData(data[0]))
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching clients"))
      .finally(() => {  });
  };
  
  React.useEffect(() => { getSubClientsData(); }, []);

  React.useEffect(() => {
    setData(tableData);
  }, [tableData]);

  const table = useReactTable({
    data,
    columns:
      roleData?.[0]?.settlement?.value?.approve_settlement ||
      roleData?.[0]?.settlement?.value?.download_settlement ||
      roleData?.[0]?.settlement?.value?.edit_settlement ||
      roleData?.[0]?.settlement?.value?.delete_settlement
        ? columns
        : columns2,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const handleValueChange = (e: any) => {
    onValueChange(e);
    setSearchVal(e);
  };

  const handleApproveClose = () => {
    setUSDTForexRate([]);
    setApproveErrors([]);
    setTableApproveData(null);
    setNetPayout({
      usdtForex: null,
      withdrawalFee: null,
      settlementFee: null,
      hash: null,
    });
    setIsCloseAppModal(true);
    setTimeout(() => {
      setIsCloseAppModal(false);
      setIsopenApprove(false);
    }, 300);
  };

  const handleClose = () => {
    setDeleteRowId("");
    setIsCloseModal(true);
    setTimeout(() => {
      setIsCloseModal(false);
      setIsopenDelete(false);
    }, 300);
  };

  return (
    <div className="st-card">
      {/* ── Header ── */}
      <div className="st-header">
        <div className="st-header-left">
          <div className="st-header-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
          </div>
          <div>
            <h3 className="st-title">Settlement List</h3>
            <p className="st-subtitle">
              {totalItems > 0
                ? `${totalItems} total record${totalItems !== 1 ? "s" : ""}`
                : "No records found"}
            </p>
          </div>
        </div>
        <div className="st-header-right">
          {/* {singleRoleData?.[0]?.settlement?.value?.generate_settlement_report && (
            <CrerateSettlementReport
              allOrgDetails={allOrgDetails}
              fetchAllsettlement={fetchAllsettlement}
            />
            )} */}
          <div className="st-search-wrap">
            <FilterModal
              subClientsData={subClientsData} setPage={props.setPage}
              filter={filter} setFilter={setFilter} roleData={roleData}
              setClearClick={setClearClick} 
              fetchAllsettlement={fetchAllsettlement}
              allOrgDetails={allOrgDetails}
              filterData={filterData}
            />
            <Searchbox onSearch={handleValueChange} />
          </div>
        </div>
      </div>

      {isDownloadFile && (
        <div className="st-download-notice">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Preparing your download…
        </div>
      )}

      {/* ── Table ── */}
      <div className="st-table-wrap">
        {props.isLoading ? (
          <div className="st-loading">
            <div className="st-spinner" />
            <p className="st-loading-txt">Loading settlements…</p>
          </div>
        ) : (
          <table className="st-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th
                      key={h.id}
                      colSpan={h.colSpan}
                      onClick={h.column.getToggleSortingHandler()}
                      className="st-thead-th"
                    >
                      <div className="st-th-inner">
                        {flexRender(
                          h.column.columnDef.header,
                          h.getContext()
                        )}
                        {h.column.getCanSort() && (
                          <span className="st-sort-icon">
                            {h.column.getIsSorted() === "asc" ? (
                              <BsArrowUp size={11} />
                            ) : h.column.getIsSorted() === "desc" ? (
                              <BsArrowDown size={11} />
                            ) : (
                              <RiArrowUpDownFill size={11} />
                            )}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <tr
                    key={row.id}
                    className={`st-tbody-tr${
                      ri % 2 !== 0 ? " st-tbody-tr--alt" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="st-tbody-td">
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>
                    <div className="st-empty">
                      <div className="st-empty-icon">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect x="2" y="5" width="20" height="14" rx="2" />
                          <line x1="2" y1="10" x2="22" y2="10" />
                        </svg>
                      </div>
                      <p className="st-empty-title">No settlements found</p>
                      <p className="st-empty-sub">
                        Try adjusting your search or create a new settlement
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* ── Pagination ── */}
      <div className="st-pagination-wrap">
        <Pagination
          setPage={setPage}
          page={page}
          totalpage={totalpage}
          currentPage={currentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          arraySize={[50, 100, 200]}
        />
      </div>

      {/* ══════════════════════════════════════════
          DELETE MODAL — slide panel
      ══════════════════════════════════════════ */}
      <Modal isOpen={isOpenDelete} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div
          className={`sdm-panel${
            isOpenDelete && !isCloseModal
              ? " sdm-panel--open"
              : " sdm-panel--close"
          }`}
        >
          <div className="prof-glow prof-glow--red" />
          {/* Header */}
          <div className="sdm-header">
            <div className="sdm-header-left">
              <div className="sdm-header-icon">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14H6L5 6" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M9 6V4h6v2" />
                </svg>
              </div>
              <div>
                <h2 className="sdm-header-title">Delete Settlement</h2>
                <p className="sdm-header-sub">This action cannot be undone</p>
              </div>
            </div>
            <button
              className="sdm-close-btn"
              onClick={handleClose}
              aria-label="Close"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="sdm-body">
            <div className="sdm-warning-card">
              <div className="sdm-warning-icon-wrap">
                <MdWarning size={22} />
              </div>
              <div className="sdm-warning-content">
                <p className="sdm-warning-title">Irreversible Action</p>
                <p className="sdm-warning-desc">
                  Are you sure you want to delete this settlement record? All
                  associated data will be permanently removed and cannot be
                  recovered.
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="sdm-footer">
            <div className="sdm-footer-note">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              Confirm your intent before proceeding
            </div>
            <div className="sdm-footer-btns">
              <button className="sdm-btn-cancel" onClick={handleClose}>
                Cancel
              </button>
              <button
                className="sdm-btn-delete"
                onClick={deleteSettlementReportFun}
                disabled={!!isDeleteLoading}
              >
                {isDeleteLoading ? (
                  <span className="sdm-spinner" />
                ) : (
                  <>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="3 6 5 6 21 6" />
                      <path d="M19 6l-1 14H6L5 6" />
                      <path d="M10 11v6" />
                      <path d="M14 11v6" />
                    </svg>
                    Delete Record
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ══════════════════════════════════════════
          APPROVE MODAL — slide panel
      ══════════════════════════════════════════ */}
      <Modal isOpen={isOpenApprove} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div
          className={`sam-panel${
            isOpenApprove && !isCloseAppModal
              ? " sam-panel--open"
              : " sam-panel--close"
          }`}
        >
          <div className="smt-top-glow" />
          {/* Header */}
          <div className="sam-header">
            <div className="sam-header-left">
              <div className="sam-header-icon">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <div>
                <h2 className="sam-header-title">
                  {TableApproveData?.organization?.name
                    ? `${TableApproveData.organization.name} — Approve Settlement`
                    : "Approve Settlement"}
                </h2>
                <p className="sam-header-sub">
                  Review details and confirm approval
                </p>
              </div>
            </div>
            <button
              className="sam-close-btn"
              onClick={handleApproveClose}
              aria-label="Close"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="sam-body">
            {loadingApproveSettlement ? (
              <div className="sam-loading">
                <div className="sam-spinner" />
                <p className="sam-loading-txt">Loading settlement data…</p>
              </div>
            ) : (
              <>
                {TableApproveData?.settlement_history_details?.map(
                  (sData: any) => (
                    <div key={sData?.summary_currency} className="sam-currency-block">
                      <div className="sam-currency-badge">
                        {sData?.summary_currency}
                      </div>

                      {/* Summary mini-table */}
                      <div className="sam-summary-table-wrap">
                        <table className="sam-summary-table">
                          <thead>
                            <tr>
                              {[
                                "Total Volume",
                                "Total Deductions",
                                "Total Charges",
                                "Total Held",
                                "Total Reserve",
                                "Net Payout",
                              ].map((col, i) => (
                                <th key={i} className="sam-summary-th">
                                  {col}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="sam-summary-td">{`${
                                sData?.summary_report_table_details
                                  ?.total_volume_count
                              }(${sData?.currency_symbol || ""}${Number(
                                sData?.summary_report_table_details
                                  ?.total_volume
                              )?.toFixed(2)})`}</td>
                              <td className="sam-summary-td">{`${
                                sData?.summary_report_table_details
                                  ?.total_deductions_count
                              }(${sData?.currency_symbol || ""}${Number(
                                sData?.summary_report_table_details
                                  ?.total_deductions
                              )?.toFixed(2)})`}</td>
                              <td className="sam-summary-td">{`${
                                sData?.summary_report_table_details
                                  ?.total_charges_count
                              }(${sData?.currency_symbol || ""}${Number(
                                sData?.summary_report_table_details
                                  ?.total_charges
                              )?.toFixed(2)})`}</td>
                              <td className="sam-summary-td">{`${
                                sData?.currency_symbol || ""
                              }${Number(
                                sData?.summary_report_table_details?.total_held
                              )?.toFixed(2)}`}</td>
                              <td className="sam-summary-td">{`${
                                sData?.currency_symbol || ""
                              }${Number(
                                sData?.summary_report_table_details
                                  ?.total_reserve
                              )?.toFixed(2)}`}</td>
                              <td className="sam-summary-td sam-summary-td--highlight">{`${
                                sData?.currency_symbol || ""
                              }${Number(
                                sData?.summary_report_table_details?.net_payout
                              )?.toFixed(2)}`}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Forex inputs */}
                      <div className="sam-field-row">
                        <div className="sam-field-group">
                          <label className="sam-label">
                            USDT Forex Rate{" "}
                            <span className="sam-req">*</span>
                          </label>
                          <input
                            className={`sam-input${
                              apprveErrors?.forex_rate?.[
                                sData?.summary_currency
                              ]
                                ? " sam-input--error"
                                : ""
                            }`}
                            type="number"
                            placeholder="Enter USDT Forex Rate"
                            id={sData?.summary_currency}
                            value={
                              USDTForexRate?.find(
                                (f: any) =>
                                  f.currency === sData.summary_currency
                              )?.forex_rate ?? ""
                            }
                            disabled={settlmenetStatus}
                            onChange={(e) => {
                              const name = e.target.id;
                              let value = e.target?.value;
                              const numVal = Number(
                                Number(value)?.toFixed(8)
                              );
                              setApproveErrors((prev: any) => ({
                                ...prev,
                                forex_rate: {
                                  ...prev?.forex_rate,
                                  [name]: "",
                                },
                              }));
                              if (numVal >= 0 && numVal <= 100) {
                                setUSDTForexRate((prev: any) => {
                                  if (
                                    prev?.filter(
                                      (f: any) => f.currency == name
                                    )?.length > 0
                                  ) {
                                    return prev?.map((mData: any) => {
                                      if (mData?.currency == name) {
                                        return {
                                          ...mData,
                                          currency: name,
                                          forex_rate: numVal,
                                          netPayOut:
                                            Number(
                                              sData
                                                ?.summary_report_table_details
                                                ?.net_payout
                                            ) * numVal,
                                        };
                                      }
                                      return mData;
                                    });
                                  } else {
                                    return [
                                      ...prev,
                                      {
                                        currency: name,
                                        forex_rate: numVal,
                                        netPayOut:
                                          Number(
                                            sData
                                              ?.summary_report_table_details
                                              ?.net_payout
                                          ) * numVal,
                                      },
                                    ];
                                  }
                                });
                              }
                            }}
                          />
                          {apprveErrors?.forex_rate?.[
                            sData?.summary_currency
                          ] && (
                            <p className="sam-field-err">
                              {
                                apprveErrors.forex_rate[
                                  sData?.summary_currency
                                ]
                              }
                            </p>
                          )}
                        </div>
                        <div className="sam-field-group">
                          <label className="sam-label">USDT Net Payout</label>
                          <input
                            className="sam-input sam-input--readonly"
                            type="number"
                            value={String(
                              Number(
                                USDTForexRate?.filter(
                                  (f: any) =>
                                    f?.currency == sData?.summary_currency
                                )[0]?.netPayOut
                              )?.toFixed(2)
                            )}
                            readOnly
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  )
                )}

                {/* ── Summary block ── */}
                <div className="sam-totals-block">
                  <div className="sam-totals-badge">Summary</div>

                  <div className="sam-field-row">
                    <div className="sam-field-group">
                      <label className="sam-label">USDT Net Payout</label>
                      <input
                        className="sam-input sam-input--readonly"
                        type="number"
                        value={USDTForexRate?.reduce(
                          (total: any, num: any) =>
                            Number(total) + Number(num?.netPayOut),
                          0
                        )?.toFixed(2)}
                        disabled
                        readOnly
                      />
                    </div>
                    <div className="sam-field-group">
                      <label className="sam-label">
                        Settlement Fee{" "}
                        <span className="sam-req">*</span>
                      </label>
                      <input
                        className={`sam-input${
                          apprveErrors.settlementFee
                            ? " sam-input--error"
                            : ""
                        }`}
                        type="number"
                        placeholder="Enter settlement fee"
                        id="settlementFee"
                        value={netPayout?.settlementFee ?? ""}
                        disabled={settlmenetStatus}
                        onChange={(e) => {
                          const name = e.target.id;
                          const value = Number(
                            Number(e.target.value)?.toFixed(2)
                          );
                          if (value >= 0) {
                            setNetPayout((prev: any) => ({
                              ...prev,
                              [name]: value,
                            }));
                          }
                          setApproveErrors((prev: any) => ({
                            ...prev,
                            [name]:
                              e.target.value === ""
                                ? "The field is required"
                                : "",
                          }));
                        }}
                      />
                      {apprveErrors.settlementFee && (
                        <p className="sam-field-err">
                          {apprveErrors.settlementFee}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="sam-field-row">
                    <div className="sam-field-group">
                      <label className="sam-label">
                        Withdrawal Fee{" "}
                        <span className="sam-req">*</span>
                      </label>
                      <input
                        className={`sam-input${
                          apprveErrors.withdrawalFee
                            ? " sam-input--error"
                            : ""
                        }`}
                        type="number"
                        placeholder="Enter withdrawal fee"
                        id="withdrawalFee"
                        value={netPayout?.withdrawalFee ?? ""}
                        disabled={settlmenetStatus}
                        onChange={(e) => {
                          const name = e.target.id;
                          const value = Number(
                            Number(e.target.value)?.toFixed(2)
                          );
                          if (value >= 0) {
                            setNetPayout((prev: any) => ({
                              ...prev,
                              [name]: value,
                            }));
                          }
                          setApproveErrors((prev: any) => ({
                            ...prev,
                            [name]:
                              e.target.value === ""
                                ? "The field is required"
                                : "",
                          }));
                        }}
                      />
                      {apprveErrors.withdrawalFee && (
                        <p className="sam-field-err">
                          {apprveErrors.withdrawalFee}
                        </p>
                      )}
                    </div>
                    <div className="sam-field-group">
                      <label className="sam-label">USDT Total Payout</label>
                      <input
                        className="sam-input sam-input--readonly"
                        type="number"
                        value={String(
                          (
                            Number(
                              USDTForexRate?.reduce(
                                (total: any, num: any) =>
                                  Number(total) + Number(num?.netPayOut),
                                0
                              )
                            ) -
                            parseFloat(netPayout?.settlementFee || 0) -
                            parseFloat(netPayout?.withdrawalFee || 0)
                          )?.toFixed(2)
                        )}
                        disabled
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="sam-field-group">
                    <label className="sam-label">
                      Hash{settlmenetStatus ? <span className="sam-req"> *</span> : ""}
                    </label>
                    <input
                      className={`sam-input${
                        apprveErrors.hash ? " sam-input--error" : ""
                      }`}
                      type="text"
                      placeholder="Enter hash"
                      id="hash"
                      value={netPayout?.hash ?? ""}
                      disabled={!settlmenetStatus}
                      onChange={(e) => {
                        const name = e.target.id;
                        const value = e.target?.value;
                        setNetPayout((prev: any) => ({ ...prev, [name]: value }));
                        setApproveErrors((prev: any) => ({
                          ...prev,
                          [name]:
                            value === "" ? "The field is required" : "",
                        }));
                      }}
                    />
                    {apprveErrors.hash && (
                      <p className="sam-field-err">{apprveErrors.hash}</p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Footer */}
          <div className="sam-footer">
            <div className="sam-footer-note">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              Review all fields before saving
            </div>
            <div className="sam-footer-btns">
              <button className="sam-btn-cancel" onClick={handleApproveClose}>
                Cancel
              </button>
              <button
                className="sam-btn-save"
                onClick={handlesubmitApprovedSettlement}
                disabled={!!isApproveLoading}
              >
                {isApproveLoading ? (
                  <span className="sam-btn-spinner" />
                ) : settlmenetStatus ? (
                  <>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Mark As Paid
                  </>
                ) : (
                  <>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                      <polyline points="17 21 17 13 7 13 7 21" />
                      <polyline points="7 3 7 8 15 8" />
                    </svg>
                    Save
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ══════════════════════════════════════════
          STYLES
      ══════════════════════════════════════════ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* ── Card ── */
        .st-card {
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(15,23,42,0.06);
        }

        /* ── Header ── */
        .st-header {
          padding: 20px 24px 16px;
          border-bottom: 1px solid #f1f5f9;
          display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap;
        }
        .st-header-left { display: flex; align-items: center; gap: 12px; }
        .st-header-right { display: flex; align-items: center; gap: 12px; margin-left: auto; }
        .st-header-icon {
          width: 40px; height: 40px; border-radius: 11px;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          border: 1.5px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .st-title { font-size: 15px; font-weight: 700; color: #0f172a; letter-spacing: -0.2px; margin-bottom: 2px; line-height: 22px; }
        .st-subtitle { font-size: 12px; color: #94a3b8; font-weight: 500; }
        .st-search-wrap { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
        .smt-top-glow {
          height: 3px;
          background: linear-gradient(90deg,#0f2744,#2563eb,#7c3aed,#2563eb,#0f2744);
          background-size: 200% 100%;
          animation: smtGlow 3s linear infinite; flex-shrink: 0;
        }
        @keyframes smtGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .prof-glow { height: 3px; flex-shrink: 0; background-size: 200% 100%; animation: profGlow 3s linear infinite; }
        .prof-glow--red    { background: linear-gradient(90deg,#7f1d1d,#dc2626,#ef4444,#dc2626,#7f1d1d); }
        @keyframes profGlow { 0%{background-position:0%} 100%{background-position:200%} }
        
        /* ── Download notice ── */
        .st-download-notice {
          display: flex; align-items: center; gap: 8px;
          margin: 0 24px 0; padding: 10px 14px;
          background: #eff6ff; border: 1px solid #bfdbfe;
          border-radius: 10px; font-size: 12.5px; font-weight: 600; color: #2563eb;
        }

        /* ── Table container ── */
        .st-table-wrap { overflow-x: auto; }
        .st-table-wrap::-webkit-scrollbar { height: 4px; }
        .st-table-wrap::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .st-table { width: 100%; border-collapse: collapse; }

        /* ── Head ── */
        .st-thead-th {
          padding: 12px 16px 10px;
          background: #f8fafc;
          border-bottom: 1.5px solid #e2e8f0;
          text-align: left; cursor: pointer; white-space: nowrap; user-select: none;
        }
        .st-thead-th:hover { background: #f1f5f9; }
        .st-th-inner { display: flex; align-items: center; gap: 5px; }
        .st-th { font-size: 11.5px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: 0.5px; }
        .st-sort-icon { color: #94a3b8; display: flex; align-items: center; transition: color 0.15s; }
        .st-thead-th:hover .st-sort-icon { color: #2563eb; }

        /* ── Rows ── */
        .st-tbody-tr { transition: background 0.12s; }
        .st-tbody-tr:hover { background: #f8fafc; }
        .st-tbody-tr--alt { background: #fafbfc; }
        .st-tbody-tr--alt:hover { background: #f1f5f9; }
        .st-tbody-td { padding: 13px 16px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }

        /* ── Cells ── */
        .st-name-cell { display: flex; align-items: center; gap: 9px; }
        .st-org-avatar {
          width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 12px; font-weight: 700;
        }
        .st-name { font-size: 13px; font-weight: 600; color: #0f172a; white-space: nowrap; }
        .st-cell-text { font-size: 13px; font-weight: 500; color: #374151; }
        .st-date { font-size: 13px; color: #64748b; font-weight: 500; white-space: nowrap; }
        .st-payout { font-size: 13px; font-weight: 700; color: #0f172a; }
        .st-dash { color: #cbd5e1; font-weight: 400; }

        /* ── Status pills ── */
        .st-status-pill {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 5px 11px; border-radius: 8px;
          font-size: 12px; font-weight: 700; white-space: nowrap;
        }
        .st-status-pill--green {
          background: linear-gradient(135deg,#f0fdf4,#dcfce7);
          border: 1.5px solid #bbf7d0; color: #15803d;
        }
        .st-status-pill--red {
          background: linear-gradient(135deg,#fff1f2,#ffe4e6);
          border: 1.5px solid #fecdd3; color: #be123c;
        }
        .st-status-pill--amber {
          background: linear-gradient(135deg,#fffbeb,#fef3c7);
          border: 1.5px solid #fde68a; color: #b45309;
        }
        .st-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
        .st-status-dot--green { background: #16a34a; }
        .st-status-dot--red { background: #e11d48; }
        .st-status-dot--amber { background: #d97706; }

        /* ── Actions ── */
        .st-actions { display: flex; align-items: center; gap: 6px; flex-wrap: wrap;}
        .st-action-btn {
          width: 32px; height: 32px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all .15s; border: 1.5px solid;
        }
        .st-action-btn--blue {
          background: #eff6ff; border-color: #bfdbfe; color: #2563eb;
        }
        .st-action-btn--blue:hover { background: #dbeafe; border-color: #93c5fd; }
        .st-action-btn--blue-solid {
          background: #dbeafe; border-color: #93c5fd; color: #1d4ed8;
          opacity: 0.7; cursor: default;
        }
        .st-action-btn--red {
          background: #fff7f7; border-color: #fecaca; color: #dc2626;
        }
        .st-action-btn--red:hover { background: #fee2e2; border-color: #fca5a5; }

        /* ── Empty ── */
        .st-empty {
          display: flex; flex-direction: column; align-items: center;
          justify-content: center; padding: 56px 24px; gap: 10px;
        }
        .st-empty-icon {
          width: 52px; height: 52px; border-radius: 13px;
          background: #f8fafc; border: 1.5px solid #e2e8f0;
          display: flex; align-items: center; justify-content: center; color: #cbd5e1;
        }
        .st-empty-title { font-size: 14px; font-weight: 700; color: #64748b; }
        .st-empty-sub { font-size: 12.5px; color: #94a3b8; font-weight: 500; text-align: center; }

        /* ── Loading ── */
        .st-loading {
          display: flex; flex-direction: column; align-items: center;
          justify-content: center; padding: 56px; gap: 12px;
        }
        .st-spinner {
          width: 28px; height: 28px;
          border: 3px solid #e2e8f0; border-top-color: #2563eb;
          border-radius: 50%; animation: stSpin 0.7s linear infinite;
        }
        @keyframes stSpin { to { transform: rotate(360deg); } }
        .st-loading-txt { font-size: 13px; color: #94a3b8; font-weight: 500; }

        /* ── Pagination ── */
        .st-pagination-wrap { padding: 12px 16px; border-top: 1px solid #f1f5f9; background: #fafbfc; }

        /* ══════════════════════════════
           DELETE MODAL PANEL
        ══════════════════════════════ */
        .sdm-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 550px;
          background: #ffffff;
          z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -8px 0 40px rgba(15,23,42,0.15);
          transition: transform .32s cubic-bezier(0.16,1,0.3,1);
        }
        .sdm-panel--open  { transform: translateX(0); }
        .sdm-panel--close { transform: translateX(100%); }

        .sdm-header {
          padding: 15px 28px;
          background: linear-gradient(135deg,#7f1d1d 0%,#b91c1c 60%,#dc2626 100%);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .sdm-header-left { display: flex; align-items: center; gap: 14px; }
        .sdm-header-icon {
          width: 42px; height: 42px; border-radius: 11px;
          background: rgba(255,255,255,.18); border: 1.5px solid rgba(255,255,255,.28);
          display: flex; align-items: center; justify-content: center;
          color: #fff; flex-shrink: 0;
        }
        .sdm-header-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 22px; }
        .sdm-header-sub { font-size: 12.5px; color: rgba(255,255,255,.65); font-weight: 500; }
        .sdm-close-btn {
          background: rgba(255,255,255,.15); border: none; border-radius: 8px;
          width: 32px; height: 32px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: rgba(255,255,255,.8); transition: background .15s;
        }
        .sdm-close-btn:hover { background: rgba(255,255,255,.25); color: #fff; }

        .sdm-body { flex: 1; padding: 28px; display: flex; flex-direction: column; gap: 20px; overflow-y: auto; }
        .sdm-warning-card {
          display: flex; gap: 14px;
          background: linear-gradient(135deg, #fff7f7, #fee2e2);
          border: 1.5px solid #fecaca; border-radius: 14px; padding: 18px;
        }
        .sdm-warning-icon-wrap {
          width: 44px; height: 44px; border-radius: 11px;
          background: #fff; border: 1.5px solid #fecaca;
          display: flex; align-items: center; justify-content: center;
          color: #dc2626; flex-shrink: 0;
        }
        .sdm-warning-content { flex: 1; }
        .sdm-warning-title { font-size: 14px; font-weight: 700; color: #991b1b; margin-bottom: 6px; line-height: 1; }
        .sdm-warning-desc { font-size: 13px; color: #b91c1c; line-height: 1.55; font-weight: 500; }

        .sdm-footer {
          padding: 16px 28px; border-top: 1px solid #f1f5f9; background: #fafbfc;
          display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; flex-shrink: 0;
        }
        .sdm-footer-note { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #94a3b8; font-weight: 500; }
        .sdm-footer-btns { display: flex; gap: 10px; }
        .sdm-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 600; color: #64748b;
          padding: 10px 20px; border-radius: 10px; border: 1.5px solid #e2e8f0; background: #fff;
          cursor: pointer; transition: all .15s;
        }
        .sdm-btn-cancel:hover { background: #f1f5f9; border-color: #cbd5e1; color: #374151; }
        .sdm-btn-delete {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 22px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #991b1b, #dc2626);
          cursor: pointer; box-shadow: 0 4px 14px rgba(220,38,38,.3);
          transition: transform .15s, box-shadow .18s;
        }
        .sdm-btn-delete:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(220,38,38,.38); }
        .sdm-btn-delete:disabled { opacity: .5; cursor: not-allowed; transform: none; box-shadow: none; }
        .sdm-spinner {
          display: inline-block; width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,.35); border-top-color: #fff;
          border-radius: 50%; animation: sdmSpin .65s linear infinite;
        }
        @keyframes sdmSpin { to { transform: rotate(360deg); } }

        /* ══════════════════════════════
           APPROVE MODAL PANEL
        ══════════════════════════════ */
        .sam-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 680px;
          background: #ffffff;
          z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -8px 0 40px rgba(15,23,42,0.15);
          transition: transform .32s cubic-bezier(0.16,1,0.3,1);
        }
        .sam-panel--open  { transform: translateX(0); }
        .sam-panel--close { transform: translateX(100%); }

        .sam-header {
          padding: 15px 28px;
          background: linear-gradient(135deg,#0f2744 0%,#1a3d6b 60%,#1d4ed8 100%);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .sam-header-left { display: flex; align-items: center; gap: 14px; }
        .sam-header-icon {
          width: 42px; height: 42px; border-radius: 11px;
          background: rgba(255,255,255,.18); border: 1.5px solid rgba(255,255,255,.28);
          display: flex; align-items: center; justify-content: center;
          color: #fff; flex-shrink: 0;
        }
        .sam-header-title { font-size: 15px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 22px; }
        .sam-header-sub { font-size: 12px; color: rgba(255,255,255,.65); font-weight: 500; }
        .sam-close-btn {
          background: rgba(255,255,255,.15); border: none; border-radius: 8px;
          width: 32px; height: 32px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: rgba(255,255,255,.8); transition: background .15s;
        }
        .sam-close-btn:hover { background: rgba(255,255,255,.25); color: #fff; }

        .sam-body {
          flex: 1; padding: 24px 28px; display: flex; flex-direction: column; gap: 20px;
          overflow-y: auto;
        }
        .sam-body::-webkit-scrollbar { width: 4px; }
        .sam-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* Currency block */
        .sam-currency-block {
          background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px;
          padding: 18px; display: flex; flex-direction: column; gap: 14px;
        }
        .sam-currency-badge {
          display: inline-flex; align-items: center;
          padding: 4px 12px; border-radius: 7px;
          background: #1e3a8a; color: #fff;
          font-size: 12px; font-weight: 800; letter-spacing: 0.5px;
          align-self: flex-start;
        }

        /* Summary table */
        .sam-summary-table-wrap { overflow-x: auto; border-radius: 10px; border: 1px solid #e2e8f0; }
        .sam-summary-table { width: 100%; border-collapse: collapse; }
        .sam-summary-th {
          padding: 9px 12px; background: #f1f5f9;
          font-size: 10.5px; font-weight: 700; color: #374151; text-transform: uppercase;
          letter-spacing: 0.4px; text-align: left; white-space: nowrap;
          border-bottom: 1px solid #e2e8f0;
        }
        .sam-summary-td {
          padding: 9px 12px; font-size: 12.5px; font-weight: 600; color: #475569;
          border-bottom: 0; white-space: nowrap;
        }
        .sam-summary-td--highlight { color: #0f172a; font-weight: 700; }

        /* Field rows */
        .sam-field-row { display: flex; gap: 14px; }
        .sam-field-row > * { flex: 1; }
        .sam-field-group { display: flex; flex-direction: column; gap: 5px; }
        .sam-label { font-size: 12.5px; font-weight: 700; color: #374151; }
        .sam-req { color: #dc2626; }
        .sam-input {
          height: 42px; padding: 0 14px;
          border: 1.5px solid #e2e8f0; border-radius: 10px;
          background: #fff; font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px; font-weight: 500; color: #0f172a;
          outline: none; transition: border-color .15s, box-shadow .15s; width: 100%;
        }
        .sam-input:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,0.1); }
        .sam-input--error { border-color: #dc2626 !important; }
        .sam-input--error:focus { box-shadow: 0 0 0 3px rgba(220,38,38,0.1) !important; }
        .sam-input--readonly { background: #f8fafc; color: #64748b; cursor: not-allowed; }
        .sam-input:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
        .sam-field-err { font-size: 11.5px; color: #dc2626; font-weight: 600; }

        /* Totals block */
        .sam-totals-block {
          background: linear-gradient(135deg, #f8faff, #eff6ff);
          border: 1.5px solid #bfdbfe; border-radius: 14px;
          padding: 18px; display: flex; flex-direction: column; gap: 14px;
        }
        .sam-totals-badge {
          display: inline-flex; align-items: center;
          padding: 4px 12px; border-radius: 7px;
          background: #2563eb; color: #fff;
          font-size: 12px; font-weight: 800; letter-spacing: 0.5px;
          align-self: flex-start;
        }

        /* Loading state in modal */
        .sam-loading {
          display: flex; flex-direction: column; align-items: center;
          justify-content: center; padding: 60px; gap: 14px;
        }
        .sam-spinner {
          width: 30px; height: 30px;
          border: 3px solid #e2e8f0; border-top-color: #2563eb;
          border-radius: 50%; animation: samSpin .7s linear infinite;
        }
        @keyframes samSpin { to { transform: rotate(360deg); } }
        .sam-loading-txt { font-size: 13px; color: #94a3b8; font-weight: 500; }

        /* Footer */
        .sam-footer {
          padding: 16px 28px; border-top: 1px solid #f1f5f9; background: #fafbfc;
          display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; flex-shrink: 0;
        }
        .sam-footer-note { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #94a3b8; font-weight: 500; }
        .sam-footer-btns { display: flex; gap: 10px; }
        .sam-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 600; color: #64748b;
          padding: 10px 20px; border-radius: 10px; border: 1.5px solid #e2e8f0; background: #fff;
          cursor: pointer; transition: all .15s;
        }
        .sam-btn-cancel:hover { background: #f1f5f9; border-color: #cbd5e1; color: #374151; }
        .sam-btn-save {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 22px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #1e3a8a, #2563eb);
          cursor: pointer; box-shadow: 0 4px 14px rgba(37,99,235,.3);
          transition: transform .15s, box-shadow .18s;
        }
        .sam-btn-save:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(37,99,235,.38); }
        .sam-btn-save:disabled { opacity: .5; cursor: not-allowed; transform: none; box-shadow: none; }
        .sam-btn-spinner {
          display: inline-block; width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,.35); border-top-color: #fff;
          border-radius: 50%; animation: samBtnSpin .65s linear infinite;
        }
        @keyframes samBtnSpin { to { transform: rotate(360deg); } }

        @media (max-width: 700px) {
          .st-header { flex-direction: column; align-items: flex-start; }
          .st-search-wrap { width: 100%; }
          .st-thead-th, .st-tbody-td { padding: 10px 12px; }
          .sam-panel, .sdm-panel { max-width: 100%; }
          .sam-field-row { flex-direction: column; }
        }
      `}</style>
    </div>
  );
}

export default SettlementTable;